import axios from 'axios';
import apiUrl from '../../shared/config';

import * as actionTypes from './actionTypes';

export const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    };
};

export const passwordResetStart = () => {
    return {
        type: actionTypes.PASSWORD_RESET_START
    };
};

export const authSuccess = (token, accountId, authLevel, account_user_id, user_permissions, user_preferences, notifications) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        idToken: token,
        accountId: accountId,
        authLevel: authLevel,
        userId: account_user_id,
        user_permissions: user_permissions,
        user_preferences: user_preferences,
        notifications: notifications
    };
};

export const passwordResetSuccess = (responseMessage) => {
    //console.log('Reset 3 RESPONSE DATA: ', responseMessage);
    return {
        type: actionTypes.PASSWORD_RESET_SUCCESS,
        responseMessage: responseMessage,
        // idToken: token,
        // accountId: accountId,
        // authLevel: authLevel,
        // userId: account_user_id,
    };
};

// export const setLoggedIn = (loggedInState) => {
//     return {
//         type: actionTypes.LOGGED_IN_STATE,
//         loggedIn: loggedInState
//     };
// };

export const authFail = (error) => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    };
};

export const passwordResetFail = (error) => {
    return {
        type: actionTypes.PASSWORD_RESET_FAIL,
        error: error
    };
};

export const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('expirationDate');
    localStorage.removeItem('accountId');
    localStorage.removeItem('userId');
    localStorage.removeItem('authLevel');
    localStorage.removeItem('user_permissions')
    localStorage.removeItem('user_preferences')
    localStorage.removeItem('notifications')
    const url = apiUrl +'Account/logout';
    axios.post(url)
        .then(response => {
            // console.log('Logged out');
        });
    return {
        type: actionTypes.AUTH_LOGOUT
    };
};

export const checkAuthTimeout = (expirationTime) => {
    return dispatch => {
        setTimeout(() => {
            dispatch(logout());
        }, expirationTime * 1000);
    };
};

export const setUserId = (user_id) => {
    localStorage.setItem('userId', user_id);
};

export const auth = (email, password, isSignup) => {
    return dispatch => {
        dispatch(authStart());
        const authData = {
            "account_name": email,
            "account_password": password
        };

        let url = apiUrl +'Account/addAccount';
        if (!isSignup) {
            url = apiUrl +'Account/login';
        }
        axios.post(url, authData)
            .then(response => {
                if (isSignup && response.data.error_flag === 'ACCOUNT_EXISTS') {
                    dispatch(authFail('An account already exists with this user name'));
                } else if (response.data.session_id !== '') {
                    //console.log('AUTH RESPONSE DATA: ', response.data);
                    const expirationDate = new Date(new Date().getTime() + 86400 * 1000);
                    localStorage.setItem('token', response.data.session_id);
                    localStorage.setItem('expirationDate', expirationDate);
                    localStorage.setItem('accountId', response.data.account_id);
                    localStorage.setItem('userId', response.data.account_user_id);
                    localStorage.setItem('authLevel', response.data.account_level_id);
                    localStorage.setItem('user_permissions', JSON.stringify(response.data.user_permissions));
                    localStorage.setItem('user_preferences', JSON.stringify(response.data.user_preferences));
                    localStorage.setItem('notifications', JSON.stringify(response.data.notifications));
                    dispatch(authSuccess(response.data.session_id, response.data.account_id, response.data.account_level_id, response.data.account_user_id, response.data.user_permissions, response.data.user_preferences, response.data.notifications));
                    dispatch(checkAuthTimeout(86400));
                    if (isSignup) {
                        dispatch({type: actionTypes.SELECT_USER, userId: response.data.account_user_id})
                        dispatch({type: actionTypes.EDIT_USER_TOGGLE})
                        dispatch({type: actionTypes.OPEN_USER_MODAL})
                    }
                } else {
                    dispatch(authFail('User/Password not found.'));
                }
            })
            .catch(err => {
                console.warn('Auth Fail Called')
                dispatch(authFail(err));
            });
    };
};

export const passwordResetRequest = (email) => {
    return dispatch => {
        dispatch(passwordResetStart());
        const authData = {
            "account_name": email
        };
        let url = apiUrl +'Account/passwordResetRequest';
        axios.post(url, authData)
            .then(response => {
                //dispatch(authFail('Password Reset Email Sent.'));
                //console.log('Reset RESPONSE DATA: ', response.data.status);
                if (response.data.status !== '') {
                    // dispatch success and display the reset request sent message.
                    dispatch(passwordResetSuccess(response.data.status));
                } else {
                    dispatch(passwordResetFail('Password Reset Request Failed'));
                }
            })
            .catch(err => {
                dispatch(passwordResetFail(err));
            });
    };
};

export const passwordReset = (password, token) => {
    return dispatch => {
        dispatch(passwordResetStart());
        const authData = {
            "account_password": password,
            "reset_token": token
        };

        let url = apiUrl +'Account/passwordReset';
console.log('IN PW RESET FUNCTION ');
        axios.post(url, authData)
            .then(response => {
                console.log('Reset RESPONSE DATA: ', response.data.status);
                if (response.data.status !== '') {
                    //TODO dispatch success and display the reset request sent message.
                         dispatch(passwordResetSuccess(response.data.status));
                } else {
                    dispatch(passwordResetFail('Password Reset Failed'));
                }
            })
            .catch(err => {
                dispatch(passwordResetFail(err));
            });
    };
};

export const setAuthRedirectPath = (path) => {
    return {
        type: actionTypes.SET_AUTH_REDIRECT_PATH,
        path: path
    };
};

export const backToLogin = () => {
    return {
        type: actionTypes.BACK_TO_LOGIN
    }
}

export const authCheckState = () => {
    return dispatch => {
        try {
            const token = localStorage.getItem('token');
            const authLevel = localStorage.getItem('authLevel');
            const permsStr = localStorage.getItem('user_permissions')
            const perms = JSON.parse(permsStr)
            const prefStr = localStorage.getItem('user_preferences');
            const prefs = JSON.parse(prefStr);
            const notifStr = localStorage.getItem('notifications');
            const notifs = JSON.parse(notifStr);
            if (!token) {
                //dispatch(setLoggedIn(false));
                dispatch(logout());
            } else {
                const expirationDate = new Date(localStorage.getItem('expirationDate'));
                if (expirationDate <= new Date()) {
                    //dispatch(setLoggedIn(false));
                    dispatch(logout());
                } else {
                    //dispatch(setLoggedIn(true));
                    const accountId = localStorage.getItem('accountId');
                    const userId = localStorage.getItem('userId');
                    dispatch(authSuccess(token, accountId, authLevel, userId, perms, prefs, notifs));
                    dispatch(checkAuthTimeout((expirationDate.getTime() - new Date().getTime()) / 1000 ));
                }
            }
        } catch (e) {
            dispatch(logout());
        }
    };
};